module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a9-0-d2578e958a08e1774c9f61f3fe8c1eb9.jpg";